import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  dialogWrapper: {
    maxWidth: "800px",
    width: "100%",
  },
}));
